import Duration, {DurationUnits} from "../../model/Duration"
import {Box, InputAdornment, useTheme} from "@mui/material";
import TextFieldValidator from "./TextFieldValidator";
import * as React from "react";
import {useEffect, useState} from "react";
import {parseNumber} from "../../model/ModelUtilities";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import BasicMenuButton from "../controls/BasicMenuButton";

const DurationPickerValidator = ({
  name,
  label,
  value,
  required,
  disabled,
  helperText,
  sx,
  onChange
} : {
  name: string
  label: string
  value?: Duration
  required?: boolean
  disabled?: boolean
  helperText?: string
  sx?: any
  onChange?(value?: Duration): void
}) => {
  const [amount, setAmount] = useState<string>("0")
  const [units, setUnits] = useState<number>(0)

  const theme = useTheme()
  const unitOptions = ["Months", "Years" /*, "Lifetime" */]

  useEffect(() => {
    if (value) {
      setAmount(value.amount.toString())
      const index = unitOptions.indexOf(value.units)
      setUnits(index >= 0 ? index : 0)
    }
  }, [value])

  const endAdornment = (
    <InputAdornment position="end"sx={{display:"flex", width:"100px", minWidth:"100px", justifyContent:"flex-end"}}>
      <BasicMenuButton
        icon={<ArrowDropDownIcon sx={{color: theme.palette.primary.main}}/>}
        label={<span>{unitOptions[units] ?? ""}</span>}
        labelPosition="left"
        options={unitOptions}
        value={units}
        onClickOption={(index: number) => {
          setUnits(index)
          const unitsValue = unitOptions[index]
          if (unitsValue === DurationUnits.Lifetime) {
            setAmount("1")
          }
          if (onChange) {
            const duration = new Duration({
              amount: unitsValue === DurationUnits.Lifetime ?  1 : parseNumber(amount, 0),
              units: unitsValue
            })
            onChange(duration)
          }
        }}
      />
    </InputAdornment>
  )

  return (
    <Box sx={sx}>
      <TextFieldValidator
        type="string"
        validators={{required: required === true, isInt: true}}
        name={name}
        variant="standard"
        margin="dense"
        label={label}
        value={amount}
        fullWidth
        disabled={disabled}
        helperText={helperText}
        required={required}
        onChange={(event: any) => setAmount(event.target.value)}
        onBlur={(event: any) => {
          if (onChange) {
            const unitsEnum = unitOptions[units]
            const duration = new Duration({
              amount: unitsEnum === DurationUnits.Lifetime ? 1 : parseNumber(amount, 0),
              units: unitsEnum
            })
            onChange(duration)
          }
        }}
        InputProps={{
          endAdornment: endAdornment
        }}
      />
    </Box>
  )
}

export default DurationPickerValidator